import * as React from "react";

function SvgAnonym(props) {
  return <svg width={18} height={18} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M9 15a6.026 6.026 0 01-5-2.667c.025-1.667 3.334-2.583 5-2.583 1.667 0 4.975.916 5 2.583A6.026 6.026 0 019 15zM9 3.166a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0-2.5A8.333 8.333 0 1017.334 9C17.334 4.39 13.584.667 9 .667z" fill="#000" fillOpacity={0.54} /></svg>;
}

export default SvgAnonym;